import { render, staticRenderFns } from "./StockPrintTicketTpl4.vue?vue&type=template&id=66bd8565&scoped=true&"
import script from "./StockPrintTicketTpl4.vue?vue&type=script&lang=js&"
export * from "./StockPrintTicketTpl4.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTicketTpl4.vue?vue&type=style&index=0&id=66bd8565&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bd8565",
  null
  
)

export default component.exports